import { render, staticRenderFns } from "./management-ddo-roadmap-view.vue?vue&type=template&id=67f7fca9"
import script from "./management-ddo-roadmap-view.vue?vue&type=script&lang=js"
export * from "./management-ddo-roadmap-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports